import { TeamComparisonPayload, TeamComparisonRequest, TeamHolder, TeamMetadata } from '@pages/team/models/team.models'
import { parseStatics } from '@core/utils/assets.utils'
import { StaticOrientation } from '@core/enums/statics.enum'
import { findSeasonAndCompetitionByID, mapCompetition } from '@core/utils/season.utils'
import { Team, TeamComparison, TeamMatch } from '@core/models/team.models'
import { Season } from '@core/models/season-competition.models'
import { GenericMatch, Match, MatchCard } from '@core/models/match.models'
import { Aggregation } from '@features/aggregations/models/aggregations.models'

export const mapTeamSummary = (team: Team): Team => ({
  ...team,
  ...parseStatics(team.statics, [StaticOrientation.Portrait]),
  name: team.shortName || team.name,
  seasonId: team?.season?.id,
  competitionId: team?.competition?.id
})

export const buildTeamComparisonQuery = (
  payload: TeamComparisonPayload & TeamMetadata,
  aggregationDataSource: Aggregation
): TeamComparisonRequest => ({
  teamA: {
    id: payload.teamId,
    competitionId: payload.competition?.id,
    seasonId: payload.season?.id
  },
  teamB: {
    id: payload.teamIdB,
    competitionId: payload.competitionIdB,
    seasonId: payload.seasonIdB
  },
  aggregationDataSource
})

export const mapComparedTeamsToStore = ({ teamA, teamB, ...metrics }: TeamComparison, seasons: Season[]) => {
  const seasonCompetitionA = findSeasonAndCompetitionByID(seasons, teamA.seasonId, teamA.competitionId)
  const seasonCompetitionB = findSeasonAndCompetitionByID(seasons, teamB.seasonId, teamB.competitionId)

  return {
    summary: { ...teamA, season: seasonCompetitionA.season, competition: seasonCompetitionA.competition } as Team,
    teamB: { ...teamB, season: seasonCompetitionB.season, competition: seasonCompetitionB.competition } as Team,
    metrics
  }
}

export const mapTeamCardMatch = (match: GenericMatch<TeamMatch>, team: Team): MatchCard<TeamMatch> => {
  if (match && team) {
    return {
      ...match,
      navigateUrl: `matches/${match.id}`,
      season: team?.season,
      competition: mapCompetition(team?.competition)
    }
  }
}

export const teamExistOnMatch = (id: string, m: Match) => m?.homeTeam?.teamId === id || m?.awayTeam?.teamId === id

export const hasCurrentLiveMatchByTeamId = (id: string, liveMatches: Match[]) =>
  liveMatches?.findIndex((m) => teamExistOnMatch(id, m)) !== -1

export const buildTeamFetchMetricsPayload = (
  context: TeamHolder,
  isVsEnabled: boolean
): TeamComparisonPayload | Team => {
  if (isVsEnabled) {
    const comparison = context.comparison
    return {
      seasonIdB: comparison.teamB.seasonId,
      competitionIdB: comparison.teamB.competitionId,
      teamIdB: comparison.teamB.id,
      season: comparison.teamA.season,
      competition: comparison.teamA.competition,
      teamId: comparison.teamA.id
    }
  } else {
    return context.team
  }
}
